import {
  Box,
  createTheme,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { counter } from "../../../helpers/count";
import { AppState } from "../../../redux/reducers/rootReducer";
import { useStyles } from "../../../shared/styles/useStyles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { FormattedMessage } from "react-intl";
import { Colors } from "../../../shared/constants/themes/Colors";
import { CustomizedTableFooter } from "../../../components/custom/CustomizedTableFooter";
import { ProceduresBody } from "./ProceduresBody";
import { IParamProcedure } from "../../../redux/types/types";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
    fontSize: 11,
  },
});

export const ProceduresTable = () => {
  const classes = useStyles();

  const { data, value } = useSelector((state: AppState) => state.search);
  const { paramsProcedure } = useSelector(
    (state: AppState) => state.correspondence
  );
  const list: IParamProcedure[] = paramsProcedure;
  // Paginación
  const { page, rowsPerPage } = useSelector(
    (state: AppState) => state.pagination
  );
  const currentData: IParamProcedure[] = value.trim() ? data ?? [] : list;

  const count = currentData.length;
  const paginatedData =
    rowsPerPage > 0
      ? currentData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : currentData;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, count - page * rowsPerPage);

  return (
    <ThemeProvider theme={theme}>
      <TableContainer component={Paper}>
        {list.length <= 0 ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{ height: 200 }}
            className={classes.title}
          >
            <InfoOutlinedIcon style={{ fontSize: 30, color: Colors.ACCENT }} />
            <FormattedMessage id={"NoCreatedProcedures"} />
          </Box>
        ) : (
          <Table
            className={classes.table}
            size="small"
            style={{ tableLayout: "auto" }}
            aria-label="a dense table"
          >
            <TableHead className={classes.titleTable}>
              <TableRow>
                <TableCell
                  width={"15%"}
                  align="center"
                  className={classes.titleTable}
                >
                  ID
                </TableCell>
                <TableCell align="center" className={classes.titleTable}>
                  <FormattedMessage id="ProcedureLabel.NameProcedure" />{" "}
                </TableCell>
                <TableCell align="center" className={classes.titleTable}>
                  <FormattedMessage id="Time" />{" "}
                </TableCell>
                <TableCell
                  width={"20%"}
                  className={classes.titleTable}
                  align="center"
                >
                  <FormattedMessage id="Actions" />{" "}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((procedure) => (
                <ProceduresBody key={procedure.id} procedure={procedure} />
              ))}

              {emptyRows > 0 && (
                <TableRow style={{ height: 13 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            {/* --------- Footer para paginación -------- */}
            <CustomizedTableFooter count={count} page={page} rowsPerPage={rowsPerPage} />
          </Table>
        )}
      </TableContainer>
    </ThemeProvider>
  );
};
